import { useMemo } from "react";

export const useBrowserDetection = () => {
  return useMemo(() => {
    if (typeof window === "undefined") {
      return {
        isSafari: false,
        isIOS: false,
        isMobile: false,
      };
    }

    const userAgent = navigator.userAgent;

    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );

    return {
      isSafari: isSafari || isIOS,
      isIOS,
      isMobile,
    };
  }, []);
};
